module.exports = __webpack_public_path__ + "img/notes-s.637dd40d.svg";